import { atom } from "recoil";

export const withSpinner = atom({
    key: 'withSpinner',
    default: false
})